import React, { useEffect } from "react";

const DisqusComments = ({ page_url, identifier }) => {
  useEffect(() => {
    const disqus_config = () => {
      this.page.url = page_url; // Replace PAGE_URL with your page's canonical URL variable
      this.page.identifier = identifier; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
    };
    if (disqus_config !== null) {
      const d = document;
      const s = d.createElement("script");
      s.src = "https://rauru-1.disqus.com/embed.js";
      s.setAttribute("data-timestamp", +new Date());
      (d.head || d.body).appendChild(s);
      console.log("a");
    }
  }, [page_url, identifier]);
  return (
    <>
      <div id="disqus_thread"></div>

      <noscript>
        Please enable JavaScript to view the{" "}
        <a href="https://disqus.com/?ref_noscript">
          comments powered by Disqus.
        </a>
      </noscript>
    </>
  );
};

export default DisqusComments;
